module.exports = __webpack_public_path__ + "imgcvh/hero-3.da960f0b.jpg";